import EmptyState from '@rio-cloud/rio-uikit/EmptyState';
import { useIntl } from 'react-intl';

type TourStopsEmptyStateProps = {
    outerClassName?: string;
};

export const TourStopsEmptyState = ({ outerClassName = 'border-none flex-1-1 margin-0' }: TourStopsEmptyStateProps) => {
    const intl = useIntl();

    return (
        <EmptyState
            condensed
            outerClassName={outerClassName}
            headline={intl.formatMessage({
                id: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.stops.empty',
            })}
        />
    );
};
